export default __webpack_public_path__ + "static/media/travel.26f43b76.svg";